import { render, staticRenderFns } from "./InsurerDetail.vue?vue&type=template&id=d29fc070&scoped=true"
import script from "./InsurerDetail.vue?vue&type=script&lang=js"
export * from "./InsurerDetail.vue?vue&type=script&lang=js"
import style0 from "./InsurerDetail.vue?vue&type=style&index=0&id=d29fc070&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29fc070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d29fc070')) {
      api.createRecord('d29fc070', component.options)
    } else {
      api.reload('d29fc070', component.options)
    }
    module.hot.accept("./InsurerDetail.vue?vue&type=template&id=d29fc070&scoped=true", function () {
      api.rerender('d29fc070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerDetail.vue"
export default component.exports